import * as types from "./employeeTypes.js";


export const fetchEmployeeTypesRequest = () => ({
    type: types.FETCH_EMPLOYEE_TYPES_REQUEST,
});

export const fetchEmployeeTypesSuccess = (employeeTypes) => ({
    type: types.FETCH_EMPLOYEE_TYPES_SUCCESS,
    payload: employeeTypes,
});

export const fetchEmployeeTypesFailure = (error) => ({
    type: types.FETCH_EMPLOYEE_TYPES_FAILURE,
    payload: error,
});

